<template>
  <div>
     <Form label-position="top">
      <Row :gutter="8">
        <i-col span="24">
          <FormItem label="结算状态">
            <RadioGroup
          v-model="billStatus"
          type="button"
          size="small"
        >
          <Radio
            v-for="item in confirmStatus"
            :key="item.id"
            :label="item.id"
            >{{ item.name }}</Radio
          >
        </RadioGroup>
          </FormItem>
        </i-col>
        <i-col span="24">
          <FormItem label="创建周期">
          <Row :gutter="8">

            <i-col span="12" class="p-b-5">
        <DatePicker
          placeholder="起始日期"
          v-model="startDate"
          type="date"
          size="small"
          style="width: 100%"
        ></DatePicker>
      </i-col>
      <i-col span="12" class="p-b-5">
        <DatePicker
          placeholder="结束日期"
          v-model="endDate"
          type="date"
          size="small"
          placement="bottom-end"
          style="width: 100%"
        ></DatePicker>
      </i-col>
          </Row>
          </FormItem>
        </i-col>
        <i-col span="24" >
          <FormItem label="公司列表">
             <Select v-model="currentCompanyId" size="small">
          <Option v-for="(company,index) in companyArray" :key="index" :value="company.id">{{company.name}}</Option>
        </Select>
          </FormItem>
        </i-col>
        <i-col span="24" >
          <FormItem  label="关键字">
           <Row :gutter="8">
              <i-col span="18">
        <i-input
        v-model="keyword"
          type="text"
          size="small"
          clearable
          placeholder="如：编码、备注"
        ></i-input>
      </i-col>
      <i-col span="6">
       <Button
          type="primary"
          icon="ios-search"
          long
          size="small"
          :loading="loadSearch"
          @click="search"
        >
          <span v-if="!loadSearch">搜索</span>
          <span v-else>加载中...</span>
        </Button>
      </i-col>
           </Row>
          </FormItem>
        </i-col>
      </Row>

      <FormItem class="text-right">
      </FormItem>
    </Form>
    <Divider dashed><span class="divider-text">其他操作</span></Divider>
    <div class="m-b-5" >
      <Button  type="primary" size="small" @click="createNewSettlement"  v-if="isAuth('transaction_createSettlement')">新建结算</Button>
      <Button  type="success" size="small" class="m-l-5"  @click="showDownLoadProgrammeModal = true" >下载结算单</Button>
    </div>
    <createSettlement ref="createSettlement"></createSettlement>
      <Modal v-model="showDownLoadProgrammeModal">
      <h3 class="p-b-10" slot="header">请选择下载类型</h3>
      <Row>
        <i-col span="24">
          <RadioGroup v-model="downLoadProgramme" vertical>
            <Radio label="1">
                <span>全部下载</span>
            </Radio>
            <Radio label="2">
                <span>勾选下载</span>
            </Radio>
        </RadioGroup>
        </i-col>
      </Row>

      <div slot="footer">
        <Button type="text"  @click="showDownLoadProgrammeModal=false">取消</Button>
        <Button type="primary" @click="choiceDownLoadProgramme">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getcompanylistbytype } from '@/api/os/company'
import createSettlement from './CreateSettlement'
import { ParseDate, ParseDateForMonth } from '@/utils/dateFormat'
import { downloadFileRequest } from '@/utils/download'
export default {
  components: {
    createSettlement
  },
  data () {
    return {
      loadSearch: false,
      confirmStatus: [
        { id: -1, name: '全部' },
        { id: 0, name: '草稿' },
        { id: 1, name: '结算完成' }
      ],
      billStatus: 1,
      companyArray: [],
      currentCompanyId: 0,
      startDate: '',
      endDate: '',
      keyword: '',
      showDownLoadProgrammeModal: false,
      downLoadProgramme: '1'
    }
  },
  created () {
    this.currentCompanyId = this.transactionSettlementQuery.purchaserCompanyId
    this.billStatus = this.transactionSettlementQuery.billStatus
    this.startDate = this.transactionSettlementQuery.startDate
    this.endDate = this.transactionSettlementQuery.endDate
    this.keyword = this.transactionSettlementQuery.keyword
    this.initCompanyArray()
  },
  methods: {
    createNewSettlement () {
      if (this.currentCompanyId) {
        this.$refs.createSettlement.showModal(this.companyArray, this.currentCompanyId)
      }
    },
    // 获取结算方公司列表
    initCompanyArray () {
      getcompanylistbytype({ companyId: this.companyId, type: 1 }).then(res => {
        this.companyArray = res
        if (this.companyArray.length) {
          let defaultCompanyId = 0
          if (this.companyArray.filter(x => x.id === this.companyId).length) {
            defaultCompanyId = this.companyArray.filter(x => x.id === this.companyId)[0].id
          } else {
            defaultCompanyId = this.companyArray[0].id
          }
          this.currentCompanyId = this.transactionSettlementQuery.agentCompanyId || defaultCompanyId
        }
        this.searchtransactionSettlementList()
      })
    },
    search () {
      this.$store.commit('set_reconciliationNew_transactionSettlementNumber', 1)
      this.searchtransactionSettlementList()
    },
    searchtransactionSettlementList () {
      var query = {
        agentCompanyId: this.currentCompanyId,
        billStatus: this.billStatus
      }
      if (this.startDate) { query.startDate = ParseDate(this.startDate) }
      if (this.endDate) { query.endDate = ParseDate(this.endDate) }
      if (this.keyword) { query.keyword = this.keyword }

      this.$store.commit('set_reconciliationNew_transactionSettlementQuery', query)
      this.$store.commit('set_reconciliationNew_update', new Date())
    },
    choiceDownLoadProgramme () {
      const that = this
      const params = {}
      if (parseInt(that.downLoadProgramme) === 1) {
        params.agentCompanyId = that.transactionSettlementQuery.agentCompanyId
        params.startDate = that.transactionSettlementQuery.startDate
        params.endDate = that.transactionSettlementQuery.endDate
        params.keyword = that.transactionSettlementQuery.keyword
        params.billStatus = that.transactionSettlementQuery.billStatus === -1 ? null : that.transactionSettlementQuery.billStatus
        params.billType = 1
        params.publisherId = that.publisherId
      } else {
        if (!that.feeitemIds.length) {
          that.$Notice.info({ desc: '请选择要下载的条目！' })
          return
        } else {
          params.billIdArrJsonStr = JSON.stringify(that.feeitemIds)
          params.billType = 1
        }
      }

      that.downLoadExecl(params)
    },
    downLoadExecl (params) {
      let dateStr = ParseDate(new Date())
      // 全部下载
      if (parseInt(this.downLoadProgramme) === 1) {
        if (params.startDate && params.endDate) {
          dateStr = ParseDateForMonth(params.startDate) + '至' + ParseDateForMonth(params.endDate)
        }
      }
      const filename = '交易结算单(' + dateStr + ').xlsx'
      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-statement/v2/bill/exportbills', params, filename)
    }
  },
  computed: {
    companyId () {
      return this.$store.state.reconciliationNew.companyId
    },
    publisherId () {
      return this.$store.state.reconciliationNew.publisherId
    },
    transactionSettlementQuery () {
      return this.$store.state.reconciliationNew.transactionSettlementQuery
    },
    feeitemIds () {
      return this.$store.state.reconciliationNew.feeitemIds || []
    }
  }
}
</script>
